import { render, staticRenderFns } from "./ModalEstornoItemAdesao.vue?vue&type=template&id=0d2460b4"
import script from "./ModalEstornoItemAdesao.vue?vue&type=script&lang=js"
export * from "./ModalEstornoItemAdesao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports